import { useEffect, useState } from 'react';
import { WorkshiftModel } from '../../models';
import { WorkshiftsAPI } from '../../services/external/APIs';

/**
 * Devuelve los detalle del turno
 * @param typeTurnFixID number | undefined
 * @returns WorkshiftModel
 * @returns booelan
 * @returns (newState: booelan) => void
 */
export const useGetWorkshifts = (typeTurnFixID: number | undefined) => {
    const [workshiftDetails, setWorkshiftDetails] = useState<WorkshiftModel>();
    const [isLoadingData, setIsLoadingData] = useState(true);

    useEffect(() => {
        if (typeTurnFixID) {
            WorkshiftsAPI.get(typeTurnFixID).then((res) => {
                setWorkshiftDetails(res);
                setIsLoadingData(false);
            });
        }
    }, [typeTurnFixID]);

    return {
        workshiftDetails,
        isLoadingDataDetails: isLoadingData,
        setIsLoadingData,
    };
};
